"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SurveyResult = exports.Survey = exports.SurveyResultModal = exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _base = require("modals/base");

var _promisePolyfill = babelHelpers.interopRequireWildcard(require("promise-polyfill"));

var _decorators = require("decorators");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _userProfile = require("user-profile");

var _noty = require("noty");

var _animationHelper = require("animation-helper");

var _GooglePlacesField = babelHelpers.interopRequireDefault(require("GooglePlacesField"));

var _S3FileUploadControl = require("components/S3FileUploadControl");

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _temp, _class3, _class4, _class5, _class6, _class7, _class8, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _temp2, _class13, _descriptor16, _descriptor17, _temp3;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var NoOp = function NoOp() {};

var SurveyModal =
/*#__PURE__*/
function (_ReactModal) {
  babelHelpers.inherits(SurveyModal, _ReactModal);

  function SurveyModal(discussionRoot, headerInfo, trackData, discussion) {
    var _this;

    var nodeType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      child_type: 'feedback',
      parent: discussionRoot.id
    };
    babelHelpers.classCallCheck(this, SurveyModal);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(SurveyModal).call(this));
    _this.removeOnHide = true;
    _this.classList = _this.classList.concat('survey-modal');

    _this.setComponent(_react.default.createElement(Survey, _extends({}, discussionRoot, {
      trackData: trackData,
      discussion: discussion,
      modal: babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)),
      nodeType: nodeType
    }), headerInfo));

    return _this;
  }

  return SurveyModal;
}(_base.ReactModal);

exports.default = SurveyModal;

var SurveyResultModal =
/*#__PURE__*/
function (_ReactModal2) {
  babelHelpers.inherits(SurveyResultModal, _ReactModal2);

  function SurveyResultModal(surveyResult, account, date, commentNode) {
    var _this2;

    babelHelpers.classCallCheck(this, SurveyResultModal);
    _this2 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(SurveyResultModal).call(this));
    _this2.removeOnHide = true;
    _this2.classList = _this2.classList.concat('survey-modal results');

    _this2.setComponent(_react.default.createElement(SurveyResult, _extends({}, surveyResult, {
      node: commentNode,
      account: account,
      date: date
    })));

    return _this2;
  }

  return SurveyResultModal;
}(_base.ReactModal);

exports.SurveyResultModal = SurveyResultModal;
var Survey = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Survey, _Component);

  function Survey() {
    var _babelHelpers$getProt;

    var _this3;

    babelHelpers.classCallCheck(this, Survey);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Survey)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this3.state = {
      submissionComplete: false,
      submitting: false,
      surveyData: {}
    };
    babelHelpers.initializerDefineProperty(_this3, "id", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "catalogItemId", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "applicationForm", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "asScholarship", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "survey", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "report", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "children", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "trackData", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "discussion", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "nodeType", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    return _this3;
  }

  babelHelpers.createClass(Survey, [{
    key: "setValue",
    value: function setValue(questionId, answer) {
      this.setState(function (_ref) {
        var surveyData = _ref.surveyData;
        return {
          surveyData: Object.assign({}, surveyData, babelHelpers.defineProperty({}, questionId, answer))
        };
      });
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      var _this4 = this;

      if (this.submitting) return false;
      return (this.nodeType.child_type == 'report' ? this.report : this.survey).content.filter(function (v) {
        return v.required && !_this4.state.surveyData[v.id];
      }).length == 0;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this5 = this;

      this.props.modal.element.firstElementChild.addEventListener('scroll', function () {
        _this5.tempScrollPosition = _this5.props.modal.element.firstElementChild.scrollTop;
      });
    } // componentWillUpdate() {
    //	this.tempScrollPosition = this.props.modal.element.firstElementChild.scrollTop;
    // }

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.modal.element.firstElementChild.scrollTop = this.tempScrollPosition;
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      return _react.default.createElement("form", {
        className: "survey-body",
        onSubmit: this.submitSurvey
      }, this.children && _react.default.createElement("div", {
        className: "survey-header"
      }, this.children), this.state.error && _react.default.createElement("div", {
        className: "alert alert-danger"
      }, this.state.error === true ? "An error occurred submitting your ".concat(this.applicationForm ? 'application' : 'feedback', ". Try again later.") : this.state.error), (this.nodeType.child_type == 'report' ? this.report : this.survey).content.map(function (item) {
        return _react.default.createElement(SurveyItem, _extends({
          setValue: _this6.setValue,
          value: _this6.state.surveyData[item.id] || ""
        }, item, {
          key: item.id,
          disabled: _this6.state.submitting
        }));
      }), _react.default.createElement("div", {
        className: "form-submit"
      }, _react.default.createElement("button", {
        className: "btn btn-primary ".concat(this.state.submitting ? "spinning" : ''),
        "data-spin": this.state.submitting ? 'true' : void 0,
        disabled: this.state.submitting || !this.canSubmit()
      }, "Submit")));
    }
  }, {
    key: "submitSurvey",
    value: function submitSurvey(event) {
      var _this7 = this;

      event.preventDefault();

      if (this.state.submitting) {
        return;
      }

      this.setState({
        error: false,
        submitting: true
      }, function () {
        _promisePolyfill.default.all(Object.keys(_this7.state.surveyData).map(function (key) {
          return _promisePolyfill.default.resolve(_this7.state.surveyData[key]).then(function (value) {
            return babelHelpers.defineProperty({}, key, value);
          });
        })).then(function (v) {
          var x = Object.assign.apply(Object, [{}].concat(babelHelpers.toConsumableArray(v)));
          var req;

          if (_this7.applicationForm) {
            req = (0, _fetch.default)("data/application/submit", {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                comment: "",
                survey: {
                  id: _this7.survey.surveyId,
                  data: x
                },
                catalogItemId: _this7.catalogItemId,
                asScholarship: _this7.asScholarship
              })
            });
          } else {
            req = (0, _fetch.default)("data/discussion/post", {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(Object.assign({
                comment: "",
                survey: {
                  id: (_this7.nodeType.child_type == 'report' ? _this7.report : _this7.survey).surveyId,
                  data: x
                },
                trackData: _this7.trackData
              }, _this7.nodeType))
            });
          }

          req.then(function (result) {
            if (result.ok) {
              return result.status == 204 ? true : result.json();
            }

            return result.json().then(function (value) {
              throw value;
            });
          }).then(function () {
            if (_this7.applicationForm) {
              _this7.props.modal.hide();
              /*
              if (this.survey.notificationText)
              	showNotificationText(this.survey.notificationText);
              else
              	showNotificationText('Your application has been submitted.');
              */


              (0, _userProfile.userProfileUpdated)();
            } else if (_this7.nodeType.child_type == 'feedback') {
              if ($('#discussionRoot').length) {
                $(_this7.props.modal.element).on('hidden.bs.modal', function (event) {
                  (0, _animationHelper.animateToSelector)('#objectBody');
                });
                var id = $('#discussionRoot').parents('.tab-pane').attr('id');
                var E = $("a[data-toggle=\"tab\"][data-target=\"#".concat(id, "\"]")).tab('show');
                if (_this7.discussion) _this7.discussion.fetchFeedNow();
              }

              _this7.props.modal.hide();

              if (_this7.survey.notificationText) (0, _noty.showNotificationText)(_this7.survey.notificationText);else (0, _noty.showNotificationText)('Your feedback has been posted.');
            } else {
              _this7.props.modal.hide();

              (0, _noty.showNotificationText)('Your report has been sent.');
            }
          }).catch(function (e) {
            if (e.isInvalidItem) {
              _this7.setState({
                error: 'Please fill out all required questions.',
                submitting: false
              });
            } else {
              _this7.setState({
                error: true,
                submitting: false
              });
            }
          });
        });
      });
    }
  }]);
  return Survey;
}(_react.Component), _temp), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setValue"), _class.prototype), _descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "catalogItemId", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "applicationForm", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "asScholarship", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "survey", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "report", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "trackData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "nodeType", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "submitSurvey", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "submitSurvey"), _class.prototype)), _class);
exports.Survey = Survey;

var SurveyItem = function SurveyItem(props) {
  var Type = Survey[props.type];
  return _react.default.createElement(Type, props);
};

Survey.header = function (_ref3) {
  var text = _ref3.text;
  return _react.default.createElement("h1", null, text);
};

Survey.displayedText = function (_ref4) {
  var text = _ref4.text;
  return _react.default.createElement("p", null, text);
};

Survey.dropdown = (_class3 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(_class3, _Component2);

  function _class3() {
    babelHelpers.classCallCheck(this, _class3);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class3).apply(this, arguments));
  }

  babelHelpers.createClass(_class3, [{
    key: "setValue",
    value: function setValue(event) {
      this.props.setValue(this.props.id, event.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          text = _this$props.text,
          required = _this$props.required,
          options = _this$props.options,
          disabled = _this$props.disabled;
      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", {
        htmlFor: "question_".concat(id)
      }, text, required && " ", required && _react.default.createElement("span", {
        className: "required"
      }, "*")), _react.default.createElement("select", {
        className: "form-control",
        name: id,
        id: "question_".concat(id),
        onChange: this.setValue,
        value: this.props.value,
        disabled: disabled
      }, options.map(function (value) {
        return _react.default.createElement("option", {
          key: value,
          value: value
        }, value);
      })), _react.default.createElement("span", null));
    }
  }]);
  return _class3;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class3.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "setValue"), _class3.prototype)), _class3);
Survey.rating = (_class4 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(_class4, _Component3);

  function _class4() {
    babelHelpers.classCallCheck(this, _class4);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class4).apply(this, arguments));
  }

  babelHelpers.createClass(_class4, [{
    key: "setValue",
    value: function setValue(event) {
      this.props.setValue(this.props.id, event.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          text = _this$props2.text,
          required = _this$props2.required,
          options = _this$props2.options,
          disabled = _this$props2.disabled;
      return _react.default.createElement("div", {
        className: "form-group survey-buttons"
      }, _react.default.createElement("label", null, text, required && " ", required && _react.default.createElement("span", {
        className: "required"
      }, "*")), _react.default.createElement("div", {
        className: "buttons"
      }, options.map(function (value) {
        return _react.default.createElement("div", {
          className: "survey-option",
          "data-value": value,
          key: value
        }, _react.default.createElement("label", null, _react.default.createElement("input", {
          type: "checkbox",
          name: id,
          value: value,
          onChange: _this8.setValue,
          checked: value == _this8.props.value,
          disabled: disabled
        }), _react.default.createElement("span", null, value)));
      })));
    }
  }]);
  return _class4;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class4.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class4.prototype, "setValue"), _class4.prototype)), _class4);
Survey.location = (_class5 =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(_class5, _Component4);

  function _class5() {
    babelHelpers.classCallCheck(this, _class5);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class5).apply(this, arguments));
  }

  babelHelpers.createClass(_class5, [{
    key: "setValue",
    value: function setValue(place) {
      this.props.setValue(this.props.id, place);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          id = _this$props3.id,
          text = _this$props3.text,
          required = _this$props3.required,
          options = _this$props3.options,
          disabled = _this$props3.disabled;
      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", {
        htmlFor: "question_".concat(id)
      }, text, required && " ", required && _react.default.createElement("span", {
        className: "required"
      }, "*")), _react.default.createElement(_GooglePlacesField.default, {
        onChange: this.setValue,
        dark: true,
        disabled: disabled
      }));
    }
  }]);
  return _class5;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class5.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "setValue"), _class5.prototype)), _class5);
Survey.fileUpload = (_class6 =
/*#__PURE__*/
function (_Component5) {
  babelHelpers.inherits(_class6, _Component5);

  function _class6() {
    babelHelpers.classCallCheck(this, _class6);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class6).apply(this, arguments));
  }

  babelHelpers.createClass(_class6, [{
    key: "uploadCallback",
    value: function uploadCallback(value) {
      // The executor passed to DelayedPromise doesn't get invoked until someone tries resolving the promise.
      this.props.setValue(this.props.id, value ? new _promisePolyfill.DelayedPromise(function (resolve) {
        return value().then(resolve);
      }) : null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          id = _this$props4.id,
          text = _this$props4.text,
          required = _this$props4.required,
          options = _this$props4.options,
          disabled = _this$props4.disabled,
          buttonLabel = _this$props4.buttonLabel,
          fileExtensions = _this$props4.fileExtensions,
          maxFileSize = _this$props4.maxFileSize,
          blockFiles = _this$props4.blockFiles;
      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", {
        htmlFor: "question_".concat(id)
      }, text, required && " ", required && _react.default.createElement("span", {
        className: "required"
      }, "*")), _react.default.createElement(_S3FileUploadControl.S3FileUploadControl, {
        setUploadCallback: this.uploadCallback,
        generation: 1,
        buttonContent: buttonLabel ? buttonLabel : 'Upload',
        accept: (fileExtensions || "").replace(/\s/g, '') ? babelHelpers.defineProperty({}, blockFiles ? 'notExtensions' : 'extensions', fileExtensions.split(/\s+/).filter(function (v) {
          return !!v;
        })) : null,
        maxFileSize: maxFileSize * 1000000,
        selectedButtonClass: "btn btn-default btn-block btn-lg text-left btn-survey-file-selected"
      }));
    }
  }]);
  return _class6;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class6.prototype, "uploadCallback", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class6.prototype, "uploadCallback"), _class6.prototype)), _class6);
Survey.textField = (_class7 =
/*#__PURE__*/
function (_Component6) {
  babelHelpers.inherits(_class7, _Component6);

  function _class7() {
    babelHelpers.classCallCheck(this, _class7);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class7).apply(this, arguments));
  }

  babelHelpers.createClass(_class7, [{
    key: "setValue",
    value: function setValue(event) {
      this.props.setValue(this.props.id, event.target.value);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value != this.props.value && this.fakeElement && this.commentField) {
        this.updateSize();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSize();
    }
  }, {
    key: "gotCommentField",
    value: function gotCommentField(node) {
      this.commentField = node;
    }
  }, {
    key: "gotFakeElement",
    value: function gotFakeElement(node) {
      this.fakeElement = node;
    }
  }, {
    key: "updateSize",
    value: function updateSize() {
      var _this9 = this;

      if (this.fakeElement && this.commentField) {
        var v = this.props.value || "";
        var nl = this.fakeElement.childNodes;
        var cStyle = window.getComputedStyle(this.commentField);
        ['boxSizing', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight', 'borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth', 'whiteSpace', 'fontFamily', 'fontStyle', 'fontSize', 'fontWeight', 'lineHeight'].forEach(function (p) {
          return _this9.fakeElement.style[p] = cStyle[p];
        });
        this.fakeElement.style.position = 'fixed';
        this.fakeElement.style.right = '150%';
        v = v.split('\n');

        for (var i = 0; i < v.length; i++) {
          if (!nl[i]) this.fakeElement.appendChild(document.createElement('div'));
          nl[i].textContent = v[i] || '\xa0';
        }

        while (nl.length > v.length) {
          this.fakeElement.removeChild(nl[nl.length - 1]);
        }

        var w,
            tgtH,
            rowCount = this.commentFieldMinLines;
        this.commentField.style.overflow = 'hidden';

        do {
          w = this.commentField.clientWidth;
          console.log(this.fakeElement.style.width = this.fakeElement.style.boxSizing == 'border-box' ? "".concat(w, "px") : "calc(".concat(w, "px - ").concat(cStyle.paddingLeft, " - ").concat(cStyle.paddingRight, " - ").concat(cStyle.borderLeftWidth, " - ").concat(cStyle.borderRightWidth, ")")); // tgtH = this.fakeElement.offsetHeight;

          tgtH = window.getComputedStyle(this.fakeElement).height;
          console.log(this.commentField.style.height = tgtH); // this.fakeElement.style.boxSizing == 'border-box' ? `calc(${tgtH}px + 2px)` : `calc(${tgtH}px - ${cStyle.paddingTop} - ${cStyle.paddingBottom} - ${cStyle.borderTopWidth} - ${cStyle.borderBottomWidth} + 2px)`);
        } while (w != this.commentField.clientWidth);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          id = _this$props5.id,
          text = _this$props5.text,
          required = _this$props5.required,
          options = _this$props5.options,
          disabled = _this$props5.disabled;
      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", {
        htmlFor: "question_".concat(id)
      }, text, required && " ", required && _react.default.createElement("span", {
        className: "required"
      }, "*")), _react.default.createElement("textarea", {
        ref: this.gotCommentField,
        className: "form-control",
        name: id,
        id: "question_".concat(id),
        rows: "3",
        value: this.props.value,
        onChange: this.setValue,
        disabled: disabled
      }), _react.default.createElement("div", {
        className: _classList.default.join('fake-textarea', this.props.value ? '' : 'fake-textarea-placeholder'),
        ref: this.gotFakeElement
      }));
    }
  }]);
  return _class7;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class7.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "setValue"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "gotCommentField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "gotCommentField"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "gotFakeElement", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "gotFakeElement"), _class7.prototype)), _class7);
var SurveyResult = (_class8 = (_temp2 =
/*#__PURE__*/
function (_Component7) {
  babelHelpers.inherits(SurveyResult, _Component7);

  function SurveyResult() {
    var _babelHelpers$getProt2;

    var _this10;

    babelHelpers.classCallCheck(this, SurveyResult);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this10 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(SurveyResult)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this10, "contents", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this10)));
    babelHelpers.initializerDefineProperty(_this10, "actionButton", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this10)));
    babelHelpers.initializerDefineProperty(_this10, "account", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this10)));
    babelHelpers.initializerDefineProperty(_this10, "date", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this10)));
    babelHelpers.initializerDefineProperty(_this10, "node", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this10)));
    return _this10;
  }

  babelHelpers.createClass(SurveyResult, [{
    key: "render",
    value: function render() {
      var _this11 = this;

      return _react.default.createElement("div", {
        className: "survey-body"
      }, _react.default.createElement("h1", {
        className: "survey-header"
      }, this.actionButton), _react.default.createElement("div", {
        className: "person"
      }, _react.default.createElement("div", {
        className: "photo"
      }, _react.default.createElement(_ProfileImageContainer.default, {
        className: "userProfilePhoto",
        noImageClassName: "default",
        image: this.account ? this.account.photo : null,
        name: this.account ? this.account.fullName : ''
      })), _react.default.createElement("div", {
        className: "person-info"
      }, _react.default.createElement("div", {
        className: "person-name"
      }, this.account ? this.account.fullName : 'System', this.account.icons && this.account.icons.length > 0 && _react.default.createElement("span", {
        className: "account-icon-list"
      }, this.account.icons.map(function (_ref6, index) {
        var title = _ref6.title,
            icon = _ref6.icon;
        return _react.default.createElement("img", {
          key: index,
          title: title,
          src: icon,
          className: "account-icon"
        });
      }))), this.account && this.account.personTitle ? _react.default.createElement("div", {
        className: "person-title"
      }, this.account.personTitle) : null, this.date && _react.default.createElement("div", {
        className: "submit-date"
      }, this.date.format('F j, Y g:i a')))), this.contents.map(function (item, index) {
        return _react.default.createElement(SurveyResultItem, _extends({
          node: _this11.node,
          index: index,
          key: index
        }, item));
      }));
    }
  }]);
  return SurveyResult;
}(_react.Component), _temp2), (_descriptor11 = babelHelpers.applyDecoratedDescriptor(_class8.prototype, "contents", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class8.prototype, "actionButton", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class8.prototype, "account", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = babelHelpers.applyDecoratedDescriptor(_class8.prototype, "date", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class8.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class8);
exports.SurveyResult = SurveyResult;

var SurveyResultItem = function SurveyResultItem(props) {
  var Type = SurveyResult[props.type];
  return _react.default.createElement(Type, props);
};

SurveyResult.header = function (_ref7) {
  var text = _ref7.text;
  return _react.default.createElement("h1", null, text);
};

SurveyResult.displayedText = function (_ref8) {
  var text = _ref8.text;
  return _react.default.createElement("p", null, text);
};

SurveyResult.dropdown =
/*#__PURE__*/
function (_Component8) {
  babelHelpers.inherits(_class10, _Component8);

  function _class10() {
    babelHelpers.classCallCheck(this, _class10);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class10).apply(this, arguments));
  }

  babelHelpers.createClass(_class10, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          id = _this$props6.id,
          text = _this$props6.text,
          value = _this$props6.value; // if (!value) return null;

      return _react.default.createElement("div", {
        className: "form-group static-value"
      }, _react.default.createElement("label", null, text), _react.default.createElement("div", {
        className: "value"
      }, value || _react.default.createElement("i", null, "No answer provided")));
    }
  }]);
  return _class10;
}(_react.Component);

SurveyResult.rating =
/*#__PURE__*/
function (_Component9) {
  babelHelpers.inherits(_class11, _Component9);

  function _class11() {
    babelHelpers.classCallCheck(this, _class11);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class11).apply(this, arguments));
  }

  babelHelpers.createClass(_class11, [{
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          id = _this$props7.id,
          text = _this$props7.text,
          value = _this$props7.value; // if (!value) return null;

      return _react.default.createElement("div", {
        className: "form-group survey-buttons"
      }, _react.default.createElement("label", null, text), _react.default.createElement("div", {
        className: "buttons"
      }, _react.default.createElement("div", {
        className: "survey-option",
        "data-value": value,
        "data-no-answer": !value,
        key: value
      }, _react.default.createElement("label", null, _react.default.createElement("input", {
        type: "checkbox",
        checked: true,
        disabled: true
      }), _react.default.createElement("span", null, value || _react.default.createElement("i", null, "No answer provided"))))));
    }
  }]);
  return _class11;
}(_react.Component);

SurveyResult.location =
/*#__PURE__*/
function (_Component10) {
  babelHelpers.inherits(_class12, _Component10);

  function _class12() {
    babelHelpers.classCallCheck(this, _class12);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class12).apply(this, arguments));
  }

  babelHelpers.createClass(_class12, [{
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          id = _this$props8.id,
          text = _this$props8.text,
          value = _this$props8.value;
      return _react.default.createElement("div", {
        className: "form-group static-value textarea"
      }, _react.default.createElement("label", null, text), _react.default.createElement("div", {
        className: "value"
      }, value ? value.result.formatted_address : _react.default.createElement("i", null, "No answer provided")));
    }
  }]);
  return _class12;
}(_react.Component);

SurveyResult.fileUpload = (_class13 = (_temp3 =
/*#__PURE__*/
function (_Component11) {
  babelHelpers.inherits(_class13, _Component11);

  function _class13() {
    var _babelHelpers$getProt3;

    var _this12;

    babelHelpers.classCallCheck(this, _class13);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this12 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(_class13)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this12, "node", _descriptor16, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this12)));
    babelHelpers.initializerDefineProperty(_this12, "index", _descriptor17, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this12)));
    return _this12;
  }

  babelHelpers.createClass(_class13, [{
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          id = _this$props9.id,
          text = _this$props9.text,
          value = _this$props9.value,
          node = _this$props9.node,
          index = _this$props9.index;
      return _react.default.createElement("div", {
        className: "form-group static-value textarea"
      }, _react.default.createElement("label", null, text), _react.default.createElement("div", {
        className: "value"
      }, value ? _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.downloadFile
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "insert_drive_file"
      }), value.split('/').pop()) : _react.default.createElement("i", null, "No answer provided")));
    }
  }, {
    key: "downloadFile",
    value: function downloadFile(event) {
      event.preventDefault();
      window.open("data/survey/download?node=".concat(this.node.id, "&index=").concat(this.index), '_blank');
    }
  }]);
  return _class13;
}(_react.Component), _temp3), (_descriptor16 = babelHelpers.applyDecoratedDescriptor(_class13.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = babelHelpers.applyDecoratedDescriptor(_class13.prototype, "index", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class13.prototype, "downloadFile", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class13.prototype, "downloadFile"), _class13.prototype)), _class13);

SurveyResult.textField =
/*#__PURE__*/
function (_Component12) {
  babelHelpers.inherits(_class15, _Component12);

  function _class15() {
    babelHelpers.classCallCheck(this, _class15);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class15).apply(this, arguments));
  }

  babelHelpers.createClass(_class15, [{
    key: "render",
    value: function render() {
      var _this$props10 = this.props,
          id = _this$props10.id,
          text = _this$props10.text,
          value = _this$props10.value; // if (!value) return null;

      return _react.default.createElement("div", {
        className: "form-group static-value textarea"
      }, _react.default.createElement("label", null, text), _react.default.createElement("div", {
        className: "value"
      }, value || _react.default.createElement("i", null, "No answer provided")));
    }
  }]);
  return _class15;
}(_react.Component);